module.exports = __webpack_public_path__ + "img/street-map.dd61d744.svg";